const MEASUREMENT_ID = "G-EJJWVRV16R";
const SCRIPT_ID = "google-analytics-script";

const configureDataLayer = () => {
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  window.gtag("js", new Date());
  // GA4 Enhanced Measurement handles the initial page view and History API
  // route changes. Keeping page-view ownership in one place prevents the
  // duplicate events caused by combining it with a manual router hook.
  window.gtag("config", MEASUREMENT_ID);
};

const loadAnalyticsScript = () => {
  if (document.getElementById(SCRIPT_ID)) {
    return;
  }

  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.async = true;
  script.fetchPriority = "low";
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);
};

export const installAnalytics = () => {
  if (process.env.NODE_ENV !== "production") {
    return;
  }

  configureDataLayer();
  loadAnalyticsScript();
};
